<template>
  <div
    class="icon-wrapper"
    @click="copyToClipboard"
  >
    <StIcon
      v-tooltip.top-end="tooltip"
      icon-name="content-copy"
      class="copy-icon"
    />
  </div>
</template>

<script>
import StIcon from '@stilingue/st-icon';

export default {
  name: 'CopyToClipboard',
  components: {
    StIcon,
  },
  props: {
    tooltip: {
      type: String,
      default() {
        return this.$t('components.CopyToClipboard.label.tooltip.copy');
      },
    },
    content: {
      type: String,
      default: '',
    },
    messageSuccess: {
      type: String,
      default() {
        return this.$t('components.CopyToClipboard.notification.success.copy');
      },
    },
    messageError: {
      type: String,
      default() {
        return this.$t('components.CopyToClipboard.notification.error.copy');
      },
    },
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.content).then(() => {
        this.$noty.success(this.messageSuccess);
      }, (err) => {
        console.error(this.messageError, err);
        this.$noty.error(this.messageError);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .icon-wrapper {
    display: contents;
  }

  .copy-icon {
    margin-left: 15px;
    cursor: pointer;
  }
</style>
